<template>
  <span :id="'adjustment-invoice-detail-section-' + invoice.id" v-if="invoice.type === adjustmentInvoiceType">
    <i class="el-icon-search header-info-dialog-value icon-action" :id="'btn-adjustment-invoice-detail-' + invoice.id" @click="handleOpenDialog"></i>
    <el-dialog
      :id="'adjustment-detail-dialog-' + invoice.id"
      width="90%"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title=" $t('invoices.adjustment.title')"
    >
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.invoiceNum') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.number }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.adjustment.date') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.date | moment('MM/DD/YYYY') }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.posted') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.posted ? $t('common.yes') : $t('common.no') }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.billTo') }}</label>
        </el-col>
        <el-col :span="4">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="invoice.billToAccountNumber + ' ' + invoice.billToAccountName" placement="top-start">
            <span class="span-small-list">{{ invoice.billToAccountNumber }} - {{invoice.billToAccountName }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.adjustment.consignee') }}</label>
        </el-col>
        <el-col :span="4">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="invoice.consigneeAccountNumber + ' ' + invoice.consigneeAccountName" placement="top-start">
            <span class="span-small-list">{{ invoice.consigneeAccountNumber }} - {{ invoice.consigneeAccountName }}</span>
          </el-tooltip>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.deliverTo') }}</label>
        </el-col>
        <el-col :span="4">
          <el-tooltip class="item" effect="dark" :enterable="false" :content="invoice.deliverToAccountNumber + ' ' + invoice.deliverToAccountName" placement="top-start">
            <span class="span-small-list">{{ invoice.deliverToAccountNumber }} - {{ invoice.deliverToAccountName }}</span>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.adjustment.caseNumber') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.caseNumber }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.loadNum') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.loadNumber }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.adjustment.originalInvoice') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.parentNumber }}</span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.internalAdjustment') }}</label>
        </el-col>
        <el-col :span="4">
          <span class="span-small-list">{{ invoice.internalAdjustment ? $t('common.yes') : $t('common.no') }}</span>
        </el-col>
        <el-col :span="4">
          <label class="margin-bottom-small-list">{{ $t('invoices.adjustment.notes') }}</label>
        </el-col>
        <el-col :span="12">
          <span class="span-small-list">{{ invoice.notes }}</span>
        </el-col>
      </el-row>

      <el-row :gutter="20" class="default-section-header">
        <el-col :span="24" class="default-section-title">
          <span class="title-list">{{ $t('invoices.adjustment.adjustmentDetails') }}</span>
          <span class="total-amount-title">{{ $t('invoices.totalAmount') }}</span>
          <span class="total-amount-span">{{ getAmount(invoice.totalAmount) }}</span>
        </el-col>
      </el-row>

      <el-table
        size="mini"
        tooltip-effect="dark"
        v-loading="searching"
        stripe
        :data="details"
        :empty-text="$t('invoices.invoiceHasNoDetails')"
      >
        <el-table-column
          prop="shipmentNumber"
          :label="$t('invoices.adjustment.shipment')"
          min-width="2"
          align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          prop="description"
          :label="$t('invoices.adjustment.description')"
          min-width="6"
          align="left"
          header-align="center"
          :showOverflowTooltip="true" />
        <el-table-column
          :label="$t('invoices.adjustment.adjustment')"
          min-width="2"
          align="center"
          :showOverflowTooltip="true" >
        <template slot-scope="scope">
          <span> {{ getAmount( scope.row.amount) }} </span>
        </template>
      </el-table-column>
      </el-table>
      <div class="pagination-footer" v-show="totalDetails > 0">
        <span class="el-pagination__total">
          <span class="el-pagination__title">{{ $t('invoices.adjustment.totalDetails') }}</span>
          {{ totalDetails }}
        </span>
        <el-pagination
          :total="totalDetails"
          :current-page.sync="searchParams.page"
          :page-sizes="sizes"
          :page-size="searchParams.rows"
          @size-change="handleSearchChangeLimit"
          @current-change="handleSearchChangePage"
          layout="sizes, prev, pager, next, jumper"
        ></el-pagination>
    </div>
    </el-dialog>
  </span>
</template>

<script>
import constants from '@/utils/constants';

export default {
  name: 'AdjustmentInvoiceDetailDialog',
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  computed: {
    adjustmentInvoiceType() {
      return constants.INVOICE.TYPES[3].value;
    },
    sizes() {
      return constants.TABLES.DEFAULT_LIMIT_SIZES;
    }
  },
  data() {
    return {
      dialogVisible: false,
      details: [],
      totalDetails: 0,
      searching: false,
      searchParams: {
        invoiceId: 0,
        invoiceType: 0,
        rows: constants.TABLES.DEFAULT_LIMIT,
        page: constants.TABLES.DEFAULT_PAGE,
        pageResults: true
      }
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.searchParams.invoiceId = this.invoice.id;
      this.searchParams.invoiceType = this.invoice.type;
      this.handleSearch();
    },
    handleSearchChangeLimit(val) {
      this.searchParams.rows = val;
      this.searchParams.page = constants.TABLES.DEFAULT_PAGE;
      this.handleSearch();
    },
    handleSearchChangePage(val) {
      this.searchParams.page = val;
      this.handleSearch();
    },
    handleSearch() {
      this.searching = true;
      this.$store.dispatch('invoices/details', this.searchParams).then(
        (response) => {
          this.details = response.data;
          this.totalDetails = response.totalRows;
        }
      ).finally(() => {
        this.searching = false;
      });
    },
    getAmount(amount) {
      if (amount < 0) {
        return `(${this.$options.filters.currency(amount).replace('-', '')})`;
      }
      return this.$options.filters.currency(amount);
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
span[id^="adjustment-invoice-detail"] {

  th {
    line-height: 1.15;

    .cell {
      line-height: 16px;
      height: 16px;
    }
  }

  .default-section-header {
    margin-bottom: 24px;
    margin-top: 20px;
    text-align: left;

    .title-list {
      display: inline;
    }

    .total-amount-title {
      margin-left: 20px;
    }

    .total-amount-span {
      margin-left: 10px;
      font-size: 13px;
      font-weight: 400;
      color: #606266;
    }
  }
}
</style>
